import { render, staticRenderFns } from "./GalleryMain.vue?vue&type=template&id=c1d5290e&"
import script from "./GalleryMain.vue?vue&type=script&lang=js&"
export * from "./GalleryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports